import React from 'react';
import { useDashboardView } from './shared/DashboardViewContext';
import Switchboard from './mobile/Switchboard';
import MobileCaptureDashboard from './mobile/MobileCaptureDashboard';
import { trackRenderDebug, useMountDebug } from '../../utils/renderDebug';

const MobileDashboardFlow = ({
  children = [],
  allEntries,
  getUserRoleForChild,
  timelineSummary,
  onRefreshDashboard,
  onQuickEntry,
  onComposerSubmit,
  composerSaving,
  composerSavingLabel,
  composerSavingHelper,
  onTrack,
  onOpenChildReview,
  onEditChild,
  onDeleteChild,
  onInviteTeamMember,
  onGoToCareTeam,
  onDailyReport,
  onOpenSleepLog,
  onOpenFoodLog,
  onOpenBathroomLog,
  onOpenMedicalLog,
  onOpenIncident,
  onMessages,
  onAddChildClick,
  onImportLogs,
  onRefreshRoles,
  loggingRemindersByChild = {},
  loggingReminderLoadingByChild = {},
  onToggleLoggingReminder,
  childShellTarget = '',
  onChildShellTargetHandled,
  initialOpenCaptureDetailsKey = '',
  initialOpenCaptureRequestKey = '',
  timelineNavigationState = null,
}) => {
  const { activeChildId, mobileView, enterChild } = useDashboardView();
  const activeChild = children.find((child) => child.id === activeChildId) || children[0] || null;
  useMountDebug('MobileDashboardFlow');
  trackRenderDebug('MobileDashboardFlow', {
    mobileView,
    activeChildId: activeChildId || 'none',
    childCount: children.length,
  });

  if (!activeChild) {
    return null;
  }

  if (children.length > 1 && mobileView === 'switchboard') {
    return (
      <Switchboard
        children={children}
        onSelectChild={enterChild}
        onAddChild={onAddChildClick}
      />
    );
  }

  return (
      <MobileCaptureDashboard
      child={activeChild}
      children={children}
      allEntries={allEntries}
      timelineSummary={timelineSummary}
      getUserRoleForChild={getUserRoleForChild}
      onRefreshRoles={onRefreshRoles}
      onRefreshDashboard={onRefreshDashboard}
      onQuickEntry={onQuickEntry}
      onComposerSubmit={onComposerSubmit}
      composerSaving={composerSaving}
      composerSavingLabel={composerSavingLabel}
      composerSavingHelper={composerSavingHelper}
      onTrack={onTrack}
      onOpenChildReview={onOpenChildReview}
      onEditChild={onEditChild}
      onDeleteChild={onDeleteChild}
      onInviteTeamMember={onInviteTeamMember}
      onGoToCareTeam={onGoToCareTeam}
      onDailyReport={onDailyReport}
      onOpenSleepLog={onOpenSleepLog}
      onOpenFoodLog={onOpenFoodLog}
      onOpenBathroomLog={onOpenBathroomLog}
      onOpenMedicalLog={onOpenMedicalLog}
      onOpenIncident={onOpenIncident}
      onMessages={onMessages}
      onImportLogs={onImportLogs}
      onAddChildClick={onAddChildClick}
      loggingRemindersByChild={loggingRemindersByChild}
      loggingReminderLoadingByChild={loggingReminderLoadingByChild}
      onToggleLoggingReminder={onToggleLoggingReminder}
      childShellTarget={childShellTarget}
      onChildShellTargetHandled={onChildShellTargetHandled}
      initialOpenCaptureDetailsKey={initialOpenCaptureDetailsKey}
      initialOpenCaptureRequestKey={initialOpenCaptureRequestKey}
      timelineNavigationState={timelineNavigationState}
    />
  );
};

export default MobileDashboardFlow;
